<template>
  <z-scroll direction="horizontal" class="horizontal">
      <ul class="list-wrapper">
        <li
          v-for="(item, idx) in selfServiceList"
          :zz-sortid="idx" :zz-sortname="item.title"
          class="list-item"
          :key="item.id"
          @click="() => gotoPage(item.jumpUrl,item.id)"
        >
          <div class="list-item-content">
            <img class="item-image" :src="$setPicSize(item.avatarUrl)" />
            <p class="item-title">{{item.title}}</p>
          </div>
        </li>
      </ul>
    </z-scroll>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'
import native from '@zz-common/native-adapter'
import { Scroll } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
export default {
  name: 'SelfService',
  props: {
    selfServiceList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    gotoPage(linkUrl, id) {
      lego.send({
        pagetype: 'ZZUP_NEWHELPCENTER_SELFSERVICE',
        actiontype: 'NEWHELPCENTER_SELFSERVICE_CLICK',
        backup: {
          name: id
        }
      })
      native.skipToUrl({ // 跳转至指定页面
        targetUrl: linkUrl
      })
    },
    $setPicSize(url) {
      return setPicSize(url, 200, 200)
    }
  },
  components: {
    zScroll: Scroll
  }
}

</script>
<style scoped lang="less">
  @import './index.less';
</style>